import { Wheat } from "lucide-react";

const ITEMS = [
  "Sprouted Millet Protein Powders",
  "Traditional Protein Laddus",
  "3D Artisanal Chocolates",
  "Pure Badam & Wheat Halwa",
  "Cold-Pressed Smoothies & ABC Juice",
  "Fusion Laddos & Wellness Treats",
  "Handmade with Love by Kandulas",
];
const ROW = ["primary", "repeat"].flatMap((copy) => ITEMS.map((text) => ({ id: `${copy}:${text}`, text })));

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-ragi/10 bg-cream-secondary py-4" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center gap-10">
        {ROW.map((item) => (
          <span key={item.id} className="flex items-center gap-10 whitespace-nowrap">
            <span className="font-display text-lg italic text-ragi">{item.text}</span>
            <Wheat className="h-4 w-4 text-terracotta/70" />
          </span>
        ))}
      </div>
    </div>
  );
}
